module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/pen icon-3c200f55.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/pen icon.svg
// module id = ./app/web/src/assets/pen icon.svg
// module chunks = 0